// descomentar apenas para apps Laravel (fullstack)
// (nesse arquivo o token CSRF eh inserido nos headers padrao do axios)
require('./bootstrap');

/**
 * Arquivo JavaScript principal.
 * A partir daqui são incluídas todas as dependências.
 */
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue'

import Pbh from '@prodabel/piweb-lib-vue';
import keycloakvue from '@prodabel/vue-keycloak-adapter';

import router from './routes';
import store from './stores';
import helpers from './helpers/index';
import filters from './filters';
import Root from './pages/paginaRaiz.vue';
import api from './requests/api';
import scrollTo from 'vue-scrollto';
import constantes from './constants/index';

import permissions from './permissions.json'

Vue.use(scrollTo);
Vue.use(BootstrapVue, {
    "formControls": {
        "size": "sm"
    },
});

Vue.use(Pbh, {
    merge: {
        filters,
        helpers
    },
    methods: ['printMsg']

});

Vue.prototype.$helper = helpers;
Vue.prototype.$api = api;
Vue.prototype.$constantes = constantes;


helpers.getVersion().then((version) => {
    Vue.prototype.$version = version;
});

helpers.getEnv().then((env) => {
    Vue.prototype.$env = env;

    // descomentar a linha abaixo para habilitar o login
    Vue.use(keycloakvue, {
        store,
        router,
        permissions,
        //verbose: true,
        redirect_url_logout: window.location.protocol + '//' + window.location.host,
        backend_url: env.VUE_APP_URL_API,
        options: {
            redirectUri: window.location.protocol + '//' + window.location.host + window.location.pathname +
                (window.location.search ? window.location.search : ''),
        },
        optionsConst: {
            "clientId": "SIST_PBH_DOMPBH",
            "realm": "PBH",
            "url": env.ACESSO_PBH_URL,
            "auth-server-url":  env.ACESSO_PBH_URL,
            "ssl-required": "external",
            "resource": "SIST_PBH_DOMPBH",
            "public-client": true,
            "verify-token-audience": true,
            "use-resource-role-mappings": true,
            "confidential-port": 0
          }
    });

    new Vue({
        data() {
            return {
                carregando: false,
            }
        },
        store,
        router,
        render: h => h(Root),
    }).$mount('#app');
});